module.exports = __webpack_public_path__ + "static/media/user-screen.f9e12979.png";